<template>
  <div class='container main'>
      <div class='menu'>
          <button class='sendbtn' @click="showDialog(undefined,'发消息')">+发消息</button>
          <div class='btn_list'>
            <div   class='inbox item cursor' @click='goSection("inbox","all",0)' :class='{"selected":selecetedList[0]}'>
               <i style='margin-right:10px;' class="fa fa-inbox "></i><span>收件箱</span>
            </div>
             <div  class='sendbox item cursor' @click='goSection("outbox","",1)' :class='{"selected":selecetedList[1]}'>
               <i style='margin-right:10px;' class="fa fa-envelope-o"></i><span>发件箱</span>
            </div>
          </div>
          <div class='btn_list category'>
            <span class='category_label'>分类</span>
            <!-- <div style="cursor:pointer" class='inbox item' @click='goSection("/inbox","system",2)' :class='{"selected":selecetedList[2]}'>
               <i class="fa fa-circle" style='color:#4283c1;margin-right:10px;'></i><span>系统消息</span>
            </div> -->
           <div  class='inbox item cursor' v-for='(item,index) in categoryList' :key='index' @click='goSection("inbox",item.name,index+2)' :class='{"selected":selecetedList[index+2]}'>
               <i class="fa fa-circle" style='margin-right:10px;' :style='{color:item.color}'></i><span>{{item.label}}</span>
            </div>
          </div>
      </div>
      <div class='section main'>
          <!-- <router-view :category='category'></router-view> -->
          <component :is='unitName' ref='box' @detail='showDialog($event,"消息详情")' :category='category' :ajax='ajax' :config='config'></component>
      </div>
      <el-dialog :title="dialogTilte" :visible.sync="dialogVisible" :width="dialogWidth" >
          <editor v-if='dialogType== "editor"' @close='doClose' :show='dialogVisible'></editor>
          <detail v-else-if='dialogType== "detail"' :obj='props' :show='dialogVisible' :ajax='ajax' :config='config'></detail>
      </el-dialog>
  </div>  
</template>

<script>
import api from '@/com/ajax' // ajax请求封装
import hhsConfig from '@/com/config'
// import inbox from './inbox.vue'
//import outbox from './outbox.vue'
import editor from './editor.vue'
// import detail from './detail.vue'

import { inbox, detail, outbox } from 'mywayinfo-message-components'

var config = {}
config.host = hhsConfig.khsHost

export default {
  data() {
    return {
      dialogWidth: '50%',
      category: '',
      // 选中状态列表
      selecetedList: [true, false],
      categoryList: [],
      dialogVisible: false,
      dialogTilte: '',
      dialogType: 'editor',
      unitName: 'inbox',
      ajax: api,
      config: config,
      props: {
        id: '',
        type: ''
      }
    }
  },
  methods: {
    doClose() {
      this.dialogVisible = false
    },
    showDialog(payload, title) {
      this.dialogVisible = true
      this.dialogTilte = title
      if (payload === undefined) {
        this.dialogType = 'editor'
      } else {
        if (payload.status === 'outbox_detail') {
          this.dialogType = 'detail'
          this.props.id = payload.id
          this.props.type = payload.type
        }
      }
    },
    goSection(url, category, index) {
      if (category) {
        this.category = category
      }

      for (let i = 0; i < this.selecetedList.length; i++) {
        if (i === index) {
          this.selecetedList[i] = true

          console.log(this.selecetedList)
        } else {
          this.selecetedList[i] = false
        }
      }

      //this.$router.push(url)
      this.unitName = url
    }
  },
  watch: {
    dialogVisible(val, oldVal) {
      if (!val) {
        this.$refs.box.getList()
      }
    }
  },
  components: {
    inbox,
    outbox,
    editor,
    detail
  },
  created() {
    api.get(config.host + 'infoflow/message/inbox/types').then(res => {
      if (res && res.success) {
        let data = res.body
        this.categoryList = data
        let length = this.categoryList.length
        while (length > 0) {
          this.$set(this.selecetedList, this.selecetedList.length, false)

          length--
        }
      }
    })
    this.dialogWidth = 700 / document.body.clientWidth * 100 + '%'
  }
}
</script>

<style scoped>
.container.main {
  background-color: #fff;
  padding-top: 15px;
  display: flex;
  width: 100%;
  height: 930px;
  font-size: 14px;
}
.menu {
  margin-left: 10px;
  margin-right: 25px;
  width: 20%;
  height: 900px;
}
.section {
  width: 75%;
  min-height: 900px;
}
.sendbtn {
  width: 100%;
  height: 40px;
  background: #4c9bfa;
  border-radius: 5px;
  color: #eeeeee;
  border: none;
  box-shadow: 0px 0px 0px;
}
.btn_list {
  margin-top: 50px;
}
.btn_list .item {
  font-size: 14px;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 10px;
}
.btn_list .selected {
  background-color: #f5f5f5;
}
.btn_list .item:hover {
  cursor: hand;
}
.category {
}
.category .category_label {
  font-size: 16px;
  margin-left: 10px;
}
.cursor {
  cursor: pointer;
}
.cursor:hover {
  color: #3c8dbc;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/index.vue